// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f979b54b","455":"80fa8c03"}[chunkId] + ".chunk.js";
};